const initialState = {
  loading: false,
  userInfo: null,
  token: null,
  error: null,
  success: false,
  prompts:[],
  selectedPrompt:[],
  status: '',
};

const promptReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CREATE_PROMPT":
      return {
        ...state,
        status: action.payload.status,
      };
    case "GET_PROMPTS":
        return {
        ...state,
          prompts: action.payload
        }
    case "GET_PROMPT_BY_ID":
      return {
        ...state,
         selectedPrompt: action.payload
      }
    case "GET_PROMPT_BY_ID_FAIL":
      return {
         ...state,
          error: action.payload
      }
    case "PROMPT_DELETE_SUCCESS":
      return {
        ...state,
         prompts: action.payload.data
      }
    case "PROMPT_DELETE_FAIL":
      return {
         ...state,
        loading: false,
        success: false,
        error: action.payload

      }
    case "PROMPT_EDIT_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
          prompts: state.prompts.map(prompt =>
              prompt._id === action.payload._id ? action.payload : prompt
        )
      }
    case "PROMPT_EDIT_FAIL":
      return {
        ...state,
         loading: false,
        success: false,
        error: action.payload
      }
    default:
      return state;
  }
};

export default promptReducer;
